import 'bootstrap';
import 'jquery';

import './main.scss';